// app/admin/page.tsx
'use client';

import ConsentedEmails from '@/components/ui/Admin/ConsentedEmails';
import { useEffect, useState } from 'react';
import { createClient } from '@/utils/supabase/client';
import { useRouter } from 'next/navigation';
import { getUserGroup } from '@/app/actions/adminActions';
import Head from 'next/head';

export default function AdminPage() {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const supabase = createClient();
  const router = useRouter();

  useEffect(() => {
    const checkUser = async () => {
      try {
        const {
          data: { user }
        } = await supabase.auth.getUser();

        if (!user) {
          router.push('/signin'); // redirect if not signed in
          return;
        }

        const userGroups = await getUserGroup();
        if (userGroups.includes('STAFF')) {
          setIsAuthorized(true); // authorized
        } else {
          router.push('/'); // not authorized
          return;
        }
      } catch (error) {
        console.error('Error checking user:', error);
        router.push('/signin');
      } finally {
        setIsLoading(false);
      }
    };

    checkUser();
  }, [router]);

  if (isLoading) return <div>Loading...</div>;
  if (isAuthorized === null) return <div>Checking authorization...</div>;
  if (!isAuthorized) return <div>Not authorized</div>;

  return (
    <main className="p-6 bg-black w-full min-h-screen">
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      {/* Put your admin tools here */}
      <ConsentedEmails />
    </main>
  );
}
